export const ConverData = (data) => {
    try {

        if (!data) {
            return [];
        }

        return data?.map((item) => ({
            ...item,
            label: item.name || " ",
            value: +item.id,
        }));
    } catch (error) {
        console.log(error);
    }

    return [];
}

export const ConverDataName = (data) => {
    try {

        if (!data) {
            return [];
        }

        return data?.map((item) => ({
            ...item,
            label: item.name,
            value: item.name,
        }));
    } catch (error) {
        console.log(error);
    }

    return [];
}